import React from 'react';

import { SidebarOption } from './interfaces';
import GroupIcon from '@mui/icons-material/Group';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import ForumIcon from '@mui/icons-material/Forum';
import i18n from '../../translations/i18n';
import { ROUTES } from '../../routes/Routes';
import TodayIcon from '@mui/icons-material/Today';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

export const menuOptions: SidebarOption[] = [
  {
    key: 'relationship-management',
    label: i18n.t(
      'sidebar:mainMenu.clients.pages.relationshipManagement.label'
    ),
    hint: i18n.t('sidebar:mainMenu.clients.pages.relationshipManagement.hint'),
    icon: <EventRepeatIcon />,
    link: ROUTES.clients.relationshipManagement,
  },
  {
    key: 'opportunities',
    label: i18n.t('sidebar:mainMenu.opportunities.label'),
    hint: i18n.t('sidebar:mainMenu.opportunities.hint'),
    icon: <TrendingUpIcon />,
    link: ROUTES.opportunities.dashboard,
    subItems: [
      {
        key: 'opportunities-dashboard',
        label: i18n.t('sidebar:mainMenu.opportunities.pages.dashboard.label'),
        hint: 'foo',
        link: ROUTES.opportunities.dashboard,
      },
      {
        key: 'opportunities-overview',
        label: i18n.t('sidebar:mainMenu.opportunities.pages.overview.label'),
        hint: 'foo',
        link: ROUTES.opportunities.overview,
      },
    ],
  },
  {
    key: 'activities',
    label: i18n.t('sidebar:mainMenu.activities.label'),
    hint: i18n.t('sidebar:mainMenu.activities.hint'),
    icon: <TodayIcon />,
    link: ROUTES.activities.overview,
  },
  {
    key: 'activityLog',
    label: i18n.t('sidebar:mainMenu.activityLog.label'),
    hint: i18n.t('sidebar:mainMenu.activityLog.hint'),
    icon: <ForumIcon />,
    link: ROUTES.activityLog.overview,
  },
  {
    key: 'clients',
    label: i18n.t('sidebar:mainMenu.clients.label'),
    hint: i18n.t('sidebar:mainMenu.clients.hint'),
    icon: <GroupIcon />,
    link: ROUTES.clients.overview,
  },
  {
    key: 'contacts',
    label: i18n.t('sidebar:mainMenu.contacts.label'),
    hint: i18n.t('sidebar:mainMenu.contacts.hint'),
    icon: <ContactPhoneIcon />,
    link: ROUTES.contacts.overview,
  },
  {
    key: 'agents',
    label: i18n.t('sidebar:mainMenu.agents.label'),
    hint: i18n.t('sidebar:mainMenu.agents.hint'),
    icon: <PermContactCalendarIcon />,
    link: '/agents',
  },
];

export const getActiveMenuOption = (path: string): string | undefined => {
  const menuOptionLinks = menuOptions
    .slice()
    .sort((a: SidebarOption, b: SidebarOption) => b.link.length - a.link.length)
    .map((option) => option.link);

  for (let i = 0; i < menuOptions.length; i++) {
    const menuOption = menuOptionLinks[i];

    if (path.startsWith(menuOption)) {
      return menuOption;
    }
  }

  return undefined;
};
